import React from 'react';
import heroImage from '../images/heroImage.png';
import kavtekLogoTopRight from '../images/cleanLogo.jpg';
import SignIn from '../components/forms/SignIn';
import { withRouter } from 'react-router';

function signIn() {
	return (
		<>
			<SignIn />
		</>
	);
}
export default withRouter(signIn);
